import React from 'react';
import { Col, Row } from 'react-bootstrap';
import AttendancesControlClockDataTable from './AttendancesControlClockDataTable';
import TechnicalIncidentsDataTable from '../TechnicalIncidents/TechnicalIncidentsDataTable';

const AttendancesControlClockIndex = ({ match }) => {
  const isDt = match.params.is_dt;
  return (
    <>
      <Row className="mt-4 mb-1">
        <Col>
          <div className="d-flex align-items-center">
            <div className="d-flex flex-column ml-1">
              <h2 className={`mt-3 ${isDt ? 'h2-dt' : 'text-uppercase'}`}>
                {isDt ? 'Incidentes Técnicos' : 'Log de Dispositivos'}
              </h2>
            </div>
          </div>
        </Col>
      </Row>
      {isDt ? <TechnicalIncidentsDataTable /> : <AttendancesControlClockDataTable isDt={isDt} />}
    </>
  );
};

export default AttendancesControlClockIndex;
